module.exports = __webpack_public_path__ + "img/ai-requests-icon.48c70b83.svg";